import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AttendanceSettingsCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/attendance").then((r) => setS(r.data)).catch(() => {}); }, []);

  const save = async () => {
    try {
      await api.put("/settings/attendance", {
        work_start: s.work_start, work_end: s.work_end,
        grace_minutes: parseInt(s.grace_minutes) || 0, min_hours: parseInt(s.min_hours) || 0,
      });
      toast.success("Aturan absensi tersimpan");
    } catch (e) { toast.error(apiErr(e)); }
  };

  if (!s) return null;
  return (
    <Card className="rounded-2xl border-slate-200 p-6 dark:border-slate-800">
      <div className="mb-4 flex items-center gap-2">
        <Clock className="h-4 w-4 text-primary" />
        <h3 className="font-heading text-lg font-semibold">Aturan Absensi</h3>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <div className="space-y-1.5"><Label className="text-xs">Jam Masuk</Label>
          <Input data-testid="setting-work-start" type="time" value={s.work_start} onChange={(e) => setS({ ...s, work_start: e.target.value })} /></div>
        <div className="space-y-1.5"><Label className="text-xs">Jam Pulang</Label>
          <Input data-testid="setting-work-end" type="time" value={s.work_end} onChange={(e) => setS({ ...s, work_end: e.target.value })} /></div>
        <div className="space-y-1.5"><Label className="text-xs">Toleransi (menit)</Label>
          <Input data-testid="setting-grace" type="number" className="font-mono" value={s.grace_minutes} onChange={(e) => setS({ ...s, grace_minutes: e.target.value })} /></div>
        <div className="space-y-1.5"><Label className="text-xs">Min. Jam Kerja</Label>
          <Input data-testid="setting-min-hours" type="number" className="font-mono" value={s.min_hours} onChange={(e) => setS({ ...s, min_hours: e.target.value })} /></div>
      </div>
      <Button className="mt-4" data-testid="save-settings-button" onClick={save}>Simpan Aturan</Button>
    </Card>
  );
}
